import { Flex, Progress, Typography } from "antd";
import type { ZipExportPhase } from "./protocol.ts";

type ZipExportProgressProps = {
  percent: number;
  fileIndex: number;
  fileCount: number;
  phase: ZipExportPhase;
};

export const ZipExportProgress = ({
  percent,
  fileIndex,
  fileCount,
}: ZipExportProgressProps) => (
  <Flex vertical gap={4}>
    <Typography.Text type="secondary">
      {fileIndex}/{fileCount}
    </Typography.Text>
    <Progress percent={Math.round(percent)} size="small" />
  </Flex>
);
